'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { Emoji } from '@/components/between-sessions/Emoji'

// Mid-page tour nudge. Sits between the deep-dive sections and the
// closing (pricing / testimonial / FAQ / final CTA) as a soft off-
// ramp for visitors who want the full narrative before committing.
// Short horizontal band — not a full-viewport section, so it doesn't
// stall scroll momentum.
export function LandingTourNudge() {
  return (
    <section className="px-6 py-16 sm:py-20 bg-bs-secondary-50 border-y border-bs-secondary-100">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
        {/* Left: icon + copy */}
        <div className="flex items-start gap-5 text-left flex-1">
          <div className="flex-shrink-0 w-14 h-14 rounded-full bg-white border border-bs-secondary-100 flex items-center justify-center text-bs-secondary-500 shadow-[0_10px_24px_-14px_rgba(108,95,199,0.4)]">
            <Emoji name="fluent-emoji-high-contrast:play-button" size={28} />
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-bs-secondary-700 font-display font-semibold mb-1">
              Prefer a walkthrough?
            </p>
            <h3 className="font-display font-bold text-xl sm:text-2xl leading-[1.15] text-gray-900">
              See the whole thing in{' '}
              <span className="italic text-bs-secondary-500">2 minutes</span>.
            </h3>
            <p className="text-[13px] text-gray-600 mt-1.5 leading-relaxed">
              An interactive tour of every piece of the membership —
              supervision formats, referral flow, community, and tools.
            </p>
          </div>
        </div>

        {/* Right: tour CTA button */}
        <div className="flex-shrink-0">
          <Link
            href="/between-sessions/tour"
            className="group inline-flex items-center gap-3 pl-6 pr-3 py-3 text-[15px] font-display font-semibold rounded-full bg-gray-900 hover:bg-black text-white shadow-[0_10px_28px_-10px_rgba(20,20,20,0.4)] hover:-translate-y-0.5 hover:shadow-[0_16px_36px_-12px_rgba(20,20,20,0.5)] transition-all duration-200 whitespace-nowrap"
          >
            See how it works
            <span className="w-8 h-8 rounded-full bg-white/15 group-hover:bg-white/25 flex items-center justify-center transition-colors">
              <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  )
}
